import { Skeleton } from '@natu/ui/Skeleton';

export const CategoriesBarSkeleton = () => {
  return (
    <>
      <Skeleton className="h-10 lg:hidden" />
      <ul className="hidden w-fit flex-wrap gap-1 border-b border-gray-200 lg:flex">
        {Array.from({ length: 6 }).map((_, index) => (
          <li key={`category-bar-skeleton-${index}`}>
            <Skeleton className="h-12 w-32" />
          </li>
        ))}
      </ul>
    </>
  );
};
